import { render, staticRenderFns } from "./BuildingEdit.vue?vue&type=template&id=4c5f237d&scoped=true&"
import script from "./BuildingEdit.vue?vue&type=script&lang=js&"
export * from "./BuildingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5f237d",
  null
  
)

export default component.exports